import { render, staticRenderFns } from "./ParticipantsForm.vue?vue&type=template&id=0942fef0&scoped=true&"
import script from "./ParticipantsForm.vue?vue&type=script&lang=js&"
export * from "./ParticipantsForm.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsForm.vue?vue&type=style&index=0&id=0942fef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942fef0",
  null
  
)

export default component.exports